module.exports = __webpack_public_path__ + "assets/img/icon-2.3295bd59.png";